import Layout1 from '@/layout/Layout1'

export default [{
  path: '/medialibrary',
  component: Layout1,
  children: [{
    path: 'video/:id',
    component: () => import('@/components/medialibrary/maintenance/video/videoEdit')
  }, {
    path: 'video',
    component: () => import('@/components/medialibrary/maintenance/video/videoList')
  }, {
    path: 'videocat/:id',
    component: () => import('@/components/medialibrary/maintenance/videocat/videocatEdit')
  }, {
    path: 'videocat',
    component: () => import('@/components/medialibrary/maintenance/videocat/videocatList')
  }, {
    path: 'videogrp/:id',
    component: () => import('@/components/medialibrary/maintenance/videogrp/videogrpEdit')
  }, {
    path: 'videogrp',
    component: () => import('@/components/medialibrary/maintenance/videogrp/videogrpList')
  }, {
    path: 'userassign/:id',
    component: () => import('@/components/medialibrary/maintenance/userassign/userassignEdit')
  }, {
    path: 'userassign',
    component: () => import('@/components/medialibrary/maintenance/userassign/userassignList')
  }, {
    path: 'book/:id',
    component: () => import('@/components/medialibrary/maintenance/book/bookEdit')
  }, {
    path: 'book',
    component: () => import('@/components/medialibrary/maintenance/book/bookList')
  }, {
    path: 'bookcat/:id',
    component: () => import('@/components/medialibrary/maintenance/bookcat/bookcatEdit')
  }, {
    path: 'bookcat',
    component: () => import('@/components/medialibrary/maintenance/bookcat/bookcatList')
  }, {
    path: 'bookgrp/:id',
    component: () => import('@/components/medialibrary/maintenance/bookgrp/bookgrpEdit')
  }, {
    path: 'bookgrp',
    component: () => import('@/components/medialibrary/maintenance/bookgrp/bookgrpList')
  }, {
    path: 'bookupload',
    component: () => import('@/components/medialibrary/maintenance/bookupload/bookuploadEdit')
  }, {
    path: 'settings',
    component: () => import('@/components/medialibrary/maintenance/settings/settingsEdit')
  }, {
    path: 'booksdownloadinquiry',
    component: () => import('@/components/medialibrary/inquiry/booksdownload/booksdownloadInquiry')
  }, {
    path: 'videosviewedinquiry',
    component: () => import('@/components/medialibrary/inquiry/videosviewed/videosviewedInquiry')
  }]
}]
